<template>
  <hm-content>
    <div class="mb10 flex flex-start">
      <el-radio-group
        v-model="activeTab"
        size="small"
        class="mr10"
        @change="switchTabs"
      >
        <el-radio-button label="0">小程序到期提醒</el-radio-button>
        <el-radio-button label="1">短信到期提醒</el-radio-button>
      </el-radio-group>
    </div>
    <div class="mb10" v-if="activeTab == '0'">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
      >
        <div>
          <el-form-item label="基本设置：" prop="base">
            <!-- <div class="tip">{{ ruleForm.tipDescription }} </div> -->
          </el-form-item>
          <el-form-item label="到期预警天数：" prop="overdueDay">
            <el-input
              size="small"
              clearable
              class="mr20 ml10 ipt"
              maxlength="18"
              style="width: 200px"
              @input="filterGt0('overdueDay')"
              v-model.trim="ruleForm.overdueDay"
              placeholder="请输入到期预警天数"
            ></el-input>
            <span class="tip">会员到期前多少天才开始触发弹窗提醒</span>
          </el-form-item>
          <el-form-item label="到期总提醒次数：" prop="tipCount">
            <el-input
              size="small"
              clearable
              class="mr20 ml10 ipt"
              maxlength="18"
              style="width: 200px"
              @input="filterGt0('tipCount')"
              v-model.trim="ruleForm.tipCount"
              placeholder="请输入到期总提醒次数"
            ></el-input>
            <span class="tip"
              >到期预警天数内一共可以提醒多少次，默认一天一次</span
            >
          </el-form-item>
          <el-form-item label="主图：" prop="pic">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="548"
              :height="648"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="!ruleForm.pic"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip">图片尺寸建议548x648（最多上传一张）</span>
            <div class="priview" v-if="ruleForm.pic">
              <img :src="ruleForm.pic" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="toggleShow">更换</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="是否开启提醒：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#2d8"
              inactive-color="#ff4949"
              active-text="开启"
              inactive-text="关闭"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          @click="submitRuleForm('ruleForm')"
          size="small"
          type="primary"
          >保存</el-button
        >
        <el-button @click="back" size="small">返回</el-button>
      </div>
    </div>
    <div class="mb10 mt20" v-if="activeTab == '1'">
      <el-form
        :model="ruleFormSms"
        :rules="rulesSms"
        ref="ruleFormSms"
        label-width="150px"
      >
        <el-form-item label="PLUS会员类型：" prop="plusRuleId">
          <el-select
            clearable
            v-model="ruleFormSms.plusRuleId"
            placeholder="请选择PLUS会员类型"
            size="small"
            filterable
          >
            <el-option
              :label="v.name"
              :value="v.plusRuleId"
              v-for="(v, i) in memberList"
              :key="i"
            ></el-option>
          </el-select>
          <div class="form-item-tip mt10" v-html="plusDuanxinTianshuTips"></div>
        </el-form-item>
        <el-form-item
          label="距到期提醒天数："
          prop="overdueSmsReminderDateRuleList"
        >
          <el-checkbox-group
            v-model="ruleFormSms.overdueSmsReminderDateRuleList"
            @change="overdueSmsReminderDateRuleChange"
          >
            <el-checkbox v-for="(v, i) in dayList" :label="v.value" :key="i">{{
              v.name
            }}</el-checkbox>
          </el-checkbox-group>
          <div class="form-item-tip mt10" v-html="plusDuanxinTianshuTips"></div>
        </el-form-item>
        <el-form-item label="是否开启提醒：" prop="overdueSmsReminderMode">
          <el-switch
            v-model="ruleFormSms.overdueSmsReminderMode"
            active-color="#2d8"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭"
            active-value="open"
            inactive-value="close"
          ></el-switch>
          <div class="form-item-tip mt10" v-html="plusDuanxinKaiguanTips"></div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          @click="submitRuleFormSms('ruleFormSms')"
          size="small"
          type="primary"
          >保存</el-button
        >
        <el-button @click="back" size="small">返回</el-button>
      </div>
    </div>
  </hm-content>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    const patternFunc = function (rule, val, callback) {
      if (!this.ruleFormSms.overdueSmsReminderDateRuleList.length) {
        return callback(new Error("请选择距到期提醒天数"));
      }
      callback();
    }.bind(this);
    return {
      activeTab: "0",
      show: false,
      ruleForm: {
        overdueDay: "",
        tipCount: "",
        status: "0",
        pic: "https://imgcdn.hemiao100.com/hemiaoBase/plusMember/plusRenew.png",
      },
      rules: {
        overdueDay: [
          {
            required: true,
            message: "请输入到期预警天数",
            trigger: "blur",
          },
        ],
        tipCount: [
          {
            required: true,
            message: "请输入到期总提醒次数",
            trigger: "blur",
          },
        ],
        pic: {
          required: true,
          message: "请选择图片！",
          trigger: "blur",
        },
      },
      memberList: [],
      dayList: [],
      dayListDefault: [
        {
          value: "1",
          name: "前1天",
        },
        {
          value: "2",
          name: "前2天",
        },
        {
          value: "3",
          name: "前3天",
        },
        {
          value: "4",
          name: "前4天",
        },
        {
          value: "5",
          name: "前5天",
        },
        {
          value: "6",
          name: "前6天",
        },
        {
          value: "7",
          name: "前7天",
        },
        {
          value: "10",
          name: "前10天",
        },
        {
          value: "15",
          name: "前15天",
        },
      ],
      plusDuanxinLeixinTips: "",
      plusDuanxinTianshuTips: "",
      plusDuanxinKaiguanTips: "",
      ruleFormSms: {
        overdueSmsReminderMode: "close",
        plusRuleId: "",
        overdueSmsReminderDateRule: "",
        overdueSmsReminderDateRuleList: [],
        clearOtherOverdueSmsReminderDateRule: "yes",
      },
      rulesSms: {
        plusRuleId: {
          required: true,
          message: "请选择会员类型",
          trigger: "blur",
        },
        overdueSmsReminderDateRuleList: [
          {
            required: true,
            validator: patternFunc,
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
  },
  activated() {},
  methods: {
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length == 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      this.ruleForm.pic = jsonData.result;
    },
    toggleShow() {
      this.show = !this.show;
    },
    submitRuleForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.ruleForm));
          let name = "settingPlusOverdue";
          this.$store.dispatch(name, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.queryDetails();
            }
          });
        }
      });
    },
    submitRuleFormSms(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleFormSms.overdueSmsReminderDateRule =
            this.ruleFormSms.overdueSmsReminderDateRuleList.toString();
          const params = JSON.parse(JSON.stringify(this.ruleFormSms));
          console.log("params:", params);
          let name = "updateOverdueSmsReminderDateRule";
          this.$store.dispatch(name, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.queryDetails();
            }
          });
        }
      });
    },
    async basic_plus_rule_list() {
      //卡规则列表查询
      const { result } = await this.$store.dispatch("basic_plus_rule_list",{pageNo:1,pageSize:999});
      this.memberList = result.records;
      this.memberList.forEach((v) => {
        let state;
        if (v.enableState === "yes") {
          state = "(启用)";
        } else {
          state = "(停用)";
        }
        v.name = v.cardName + state;
        if (v.overdueSmsReminderMode && v.overdueSmsReminderMode === "open") {
          this.ruleFormSms.overdueSmsReminderMode = v.overdueSmsReminderMode;
          this.ruleFormSms.plusRuleId = v.plusRuleId;
          this.ruleFormSms.overdueSmsReminderDateRule =
            v.overdueSmsReminderDateRule;
          this.ruleFormSms.overdueSmsReminderDateRuleList =
            v.overdueSmsReminderDateRule.split(",");
          this.ruleFormSms.clearOtherOverdueSmsReminderDateRule = "yes";
        }
      });
      console.log("this.memberList:", this.memberList);
    },
    async getParamValueAllowNull() {
      const { code, result } = await this.$store.dispatch(
        "getParamValueAllowNull",
        {
          paramCode: "overdue_sms_reminder_before_date_rang",
        }
      );
      if (code === "0") {
        if (result.paramValue) {
          this.dayList = result.paramValue;
          let temp = result.paramValue.split(",");
          console.log("temp:", temp);
          this.dayList = temp.map((v) => {
            let num = v;
            let value = num;
            let name = "前" + num + "天";
            return {
              value: value,
              name: name,
            };
          });
        } else {
          this.dayList = this.dayListDefault;
        }
      }
    },
    back() {
      this.$router.back(-1);
    },
    async queryDetails() {
      const { code, result } = await this.$store.dispatch("queryPlusOverdue");
      if (code === "0") {
        if (result) {
          this.ruleForm = result;
          this.ruleForm.status = this.ruleForm.status.toString();
        }
      }
    },
    switchTabs(e) {
      if (e == 1) {
        this.plusDuanxinLeixin();
        this.plusDuanxinTianshu();
        this.plusDuanxinKaiguan();
        this.getParamValueAllowNull();
        this.basic_plus_rule_list();
      } else {
        this.queryDetails();
      }
    },
    overdueSmsReminderDateRuleChange() {
      console.log(
        "this.overdueSmsReminderDateRule:",
        this.ruleFormSms.overdueSmsReminderDateRule
      );
    },
    async plusDuanxinLeixin() {
      const { result } = await this.$store.dispatch("plusDuanxinLeixin");      
      this.plusDuanxinLeixinTips = result.textContentZhCn;
    },
    async plusDuanxinTianshu() {
      const { result } = await this.$store.dispatch("plusDuanxinTianshu");
      this.plusDuanxinTianshuTips = result.textContentZhCn;
    },
    async plusDuanxinKaiguan() {
      const { result } = await this.$store.dispatch("plusDuanxinKaiguan");
      this.plusDuanxinKaiguanTips = result.textContentZhCn;
      console.log("1111:",result);
    },
  },
};
</script>

<style lang="scss" scoped>
.priview {
  position: relative;
  width: 274px;
  height: 324px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.tip {
  color: #f72b2b;
}
.form-item-tip {
  width: 70%;
  line-height: 24px;
}
</style>
